import {getShowPrice} from "../utils/get_show_price";
import {PriceVisibilityType} from "../vendor/types/PriceVisibilityType";
import {useShouldHidePrices} from "./use_should_hide_prices";

interface IUseShouldShowPriceParams {
    offerPriceVisibility?: PriceVisibilityType;
    vendorPriceVisibility?: PriceVisibilityType;
    vendorId: number;
    skipAuthCheck?: boolean;
}

/**
 * Hook that determines if price should be shown based on:
 * - Offer and vendor price visibility configuration
 * - Vendor exclusion list
 * - User profile completeness (name and phone required) — skipped when `skipAuthCheck` is true
 */
export const useShouldShowPriceByOfferConfigAndUser = (params: IUseShouldShowPriceParams): boolean => {
    const {offerPriceVisibility = PriceVisibilityType.ALWAYS, vendorPriceVisibility = PriceVisibilityType.AUTO, vendorId, skipAuthCheck} = params;
    const {shouldHidePrices} = useShouldHidePrices();

    const shouldShowByConfig = getShowPrice({
        offerPriceVisibility,
        vendorPriceVisibility,
        vendorId
    });

    // Hide prices (blurred UI) if user is not logged in or has incomplete profile
    if (!skipAuthCheck && shouldHidePrices) {
        return false;
    }

    return shouldShowByConfig;
};
